import { FC, Fragment, useEffect, useState } from 'react'
import UserApi from '../../../../infrastructure/api/UserApi'
import { IUserModel } from '../../../../models/responses/UserModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { DictionaryModel } from '../../../../models/responses/DictionaryModel'
import { UserModel } from '../../../modules/auth/models/UserModel'
import { RootState } from '../../../../setup'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import CompanyApi from '../../../../infrastructure/api/CompanyApi'
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import moment from 'moment'
import { SelectModel } from '../../../models/SelectModel'
import LevelApi from '../../../../infrastructure/api/LevelApi'
import * as level from '../../../pages/levels/redux/LevelRedux'
import { IScheduleScore, IScoreStatisticsModel } from '../../../../models/responses/ScoreStatisticsModel'
import ScheduleApi from '../../../../infrastructure/api/ScheduleApi'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import { EnumToList } from '../../../helpers/EnumHelper'
import { ScheduleScoreTypeEnum } from '../../../../enums/ScheduleScoreTypeEnum'
import Select from 'react-select';
import { customSelectStyles } from '../../../helpers/ReactSelectHelper'
import { ICompanyModel } from '../../../../models/responses/CompanyModel'
import { downloadFile } from '../../../helpers/FileHelper'
import { SaveChangesButton } from '../../../components/buttons/SaveChangesButton'
import { ScheduleTypeEnum } from '../../../../enums/ScheduleTypeEnum'


type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const NativeRatingsListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [loading, setLoading] = useState(false)
  const [complete, setComplete] = useState(false)

  const levelDictionary: SelectModel[] = useSelector<RootState>(({ level }) => level.levelDictionary, shallowEqual) as SelectModel[]
  const dispatch = useDispatch()
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel

  const [scores, setScores] = useState<PagedResponseModel<IScoreStatisticsModel[]>>()

  const excelJS = require("exceljs");

  const [companiesList, setCompaniesList] = useState<ICompanyModel[]>([])
  const [companies, setCompanies] = useState<SelectModel[]>([])
  const [selectedCompany, setSelectedCompany] = useState<SelectModel>()

  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('firstName_asc')

  const scheduleScoreList = EnumToList(ScheduleScoreTypeEnum)

  let now = new Date();
  let startTime = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
  let endTime = moment(startTime).add(7, "days").subtract(1, "seconds");

  const [start, setStart] = useState(startTime)
  const [end, setEnd] = useState(endTime)

  const applyCallback = (startDate: moment.Moment, endDate: moment.Moment) => {
    setStart(startDate)
    setEnd(endDate)
    getUsers(startDate, endDate)
  }

  let ranges = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 3 Days': [moment().subtract(2, 'days'), moment()],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  }

  let local = {
    "format": "YYYY/MM/DD",
    "sundayFirst": false,
  }

  const paginationFilter: IPaginationFilter = {
    page: pageNumber,
    size: pageSize,
    orderBy: sort,
    search: searchText
  }

  async function init() {
    if (levelDictionary.length < 1) {
      var responseLevels = await LevelApi.GetLevelDictionary()
      var dataLevels: SelectModel[] = [...responseLevels.data.map(d => ({
        value: d.id.toString(),
        label: d.name
      }))]
      dispatch(level.actions.setLevelDictionary(dataLevels));
    }

    if (companies.length < 1 && user.companyId) {
      var companiesQuery = await CompanyApi.GetSubCompaniesDictionary(user.companyId);
      var dataParentCompanies: SelectModel[] = [
        ...companiesQuery.data.map((d) => ({
          value: d.id.toString(),
          label: d.name,
        })),
      ]
      setCompanies(dataParentCompanies)
      setCompaniesList(companiesQuery.data)
    }

    getUsers(start, end);
  }


  useEffect(() => {
    init();

  }, [refresh, pageNumber, pageSize, searchText, sort, selectedCompany])

  const generateRow = (scores: IScheduleScore[]) => {
    return (
      <Fragment>
        <tr>
          <td colSpan={2}></td>
          <td>
            {scores.length > 0 ?
              <TableContainer component={Paper} className={"mt-5"}>
                <Table size={'small'} aria-label="a dense table">
                  <TableHead style={{ backgroundColor: '#e9e9e9' }}>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell align='right'>Score</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {scores.map((row, index) => {
                      return (
                        <Fragment key={row.type}>
                          <TableRow>
                            <TableCell>{scheduleScoreList.find(i => i.value == row.type.toString())?.label!.toString().replace(/([A-Z])/g, ' $1').trim()}</TableCell>
                            <TableCell align='right' >%{(row.score * 10).toFixed(1)}</TableCell>
                          </TableRow>
                        </Fragment>
                      )
                    }
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              :
              <div className="alert alert-dismissible bg-primary d-flex flex-column flex-sm-row p-5 mb-10 mt-5">
                <div className="d-flex flex-column text-light pe-0 pe-sm-10">
                  <span>No was ratings.</span>
                </div>
              </div>

            }
          </td>
        </tr>
      </Fragment >

    )
  }

  const options = {
    rowsPerPage: pageSize,
    search: true,
    expandableRows: true,
    renderExpandableRow: (rowData: any, rowMeta: any) => {
      var score = scores?.items[rowMeta.rowIndex];
      return (
        generateRow(score?.scores!)
      );
    },
  };


  function recursiveParentCompany(companyFields: string[], companyId: string): any {
    var companyFields = companyFields
    var company = companiesList.find(i => i.id == companyId)
    companyFields.push(company?.name!)

    if (company?.parentCompanyId != undefined)
      companyFields = recursiveParentCompany(companyFields, company?.parentCompanyId!);

    return companyFields;
  }


  async function getReports(start: moment.Moment, end: moment.Moment, companyId: string) {
    try {
      if (user.companyId != null && user.companyId != '' && companyId != "") {
        const paginationFilter: IPaginationFilter = {
          page: 1,
          size: 9999,
          orderBy: sort,
          search: searchText
        }

        if (user.companyId && selectedCompany?.value) {

          var subCompanies = await CompanyApi.GetSubCompaniesDictionary(selectedCompany.value);

          var responseData = await ScheduleApi.GetScoreStatistics(
            paginationFilter, {
            companyIds: subCompanies.data.map(i => i.id),
            startDate: start.format("YYYY-MM-DDT00:00:00"),
            endDate: end.format("YYYY-MM-DDT23:59:59")
          });
          var maxBreakDown = 1;
          responseData.data.items.forEach(report => {

            report.companies = [];
            report.companies = recursiveParentCompany([], report.companyId)
            if (report.companies.length > maxBreakDown) maxBreakDown = report.companies.length;

            for (var i = 0; i < report.companies.length; i++) {
              switch (i) {
                case 0: report.company0 = report.companies.reverse()[i]; break;
                case 1: report.company1 = report.companies.reverse()[i]; break;
                case 2: report.company2 = report.companies.reverse()[i]; break;
                case 3: report.company3 = report.companies.reverse()[i]; break;
                case 4: report.company4 = report.companies.reverse()[i]; break;
                case 5: report.company5 = report.companies.reverse()[i]; break;
                case 6: report.company6 = report.companies.reverse()[i]; break;
                case 7: report.company7 = report.companies.reverse()[i]; break;
                case 8: report.company8 = report.companies.reverse()[i]; break;
                case 9: report.company9 = report.companies.reverse()[i]; break;
              }
            }

            report.scores.map((item, key) => {
              switch (item.type) {
                case ScheduleScoreTypeEnum.CallQuality: report.score1 = "%" + (item.score * 10).toFixed(1).toString(); break;
                case ScheduleScoreTypeEnum.Confidence: report.score2 = "%" + (item.score * 10).toFixed(1).toString(); break;
                case ScheduleScoreTypeEnum.Attendance: report.score3 = "%" + (item.score * 10).toFixed(1).toString(); break;
                case ScheduleScoreTypeEnum.VocabularyUsage: report.score4 = "%" + (item.score * 10).toFixed(1).toString(); break;
                case ScheduleScoreTypeEnum.GrammarUsage: report.score5 = "%" + (item.score * 10).toFixed(1).toString(); break;
                case ScheduleScoreTypeEnum.Pronunciation: report.score6 = "%" + (item.score * 10).toFixed(1).toString(); break;
                case ScheduleScoreTypeEnum.Fluency: report.score7 = "%" + (item.score * 10).toFixed(1).toString(); break;
                case ScheduleScoreTypeEnum.LongAndComplexSentences: report.score8 = "%" + (item.score * 10).toFixed(1).toString(); break;
                case ScheduleScoreTypeEnum.Accuracy: report.score9 = "%" + (item.score * 10).toFixed(1).toString(); break;
                case ScheduleScoreTypeEnum.Advices: report.score10 = "%" + (item.score * 10).toFixed(1).toString(); break;
              }
            })

          });
          var fields: any[] = []

          for (var i = 0; i < maxBreakDown; i++) {
            fields.push({ key: 'company' + i, header: (i == 0 ? 'Company' : '-'), width: 30 })
          }

          var fieldsScore: any[] = []
          for (var i = 1; i <= 10; i++) {
            fieldsScore.push({ key: 'score' + i, header: ScheduleScoreTypeEnum[i] })
          }


          fields = [...fields, ...[
            { key: 'firstName', header: 'First Name', width: 15 },
            { key: 'lastName', header: 'Last Name', width: 15 },
            { key: 'email', header: 'E-mail', width: 25 },
            { key: 'phoneNumber', header: 'Phone Number', width: 15 },
          ], ...fieldsScore];



          const workbook = new excelJS.Workbook();
          const worksheet = workbook.addWorksheet("Educall Native Ratings Reports");

          worksheet.columns = fields
          worksheet.getRow(1).eachCell((cell: any) => {
            cell.font = { bold: true };
          });
          worksheet.addRows(responseData.data.items);
          const buffer = await workbook.xlsx.writeBuffer();

          downloadFile(buffer, `Educall Native Ratings - (${start.format("YYYY-MM-DD")} _ ${end.format("YYYY-MM-DD")}) _ ${moment().format("YYYY-MM-DD-HH-mm-ss")}`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;');
          setComplete(true)
        }

      }
    } catch (error) {
      alert('Request timed out')
      setLoading(false)
    }
  }


  async function getUsers(start: moment.Moment, end: moment.Moment) {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText
    }

    if (user.companyId && selectedCompany?.value) {

      var companies = await CompanyApi.GetSubCompaniesDictionary(selectedCompany.value);

      var responseData = await ScheduleApi.GetScoreStatistics(
        paginationFilter, {
        companyIds: companies.data.map(i => i.id),
        startDate: start.format("YYYY-MM-DDT00:00:00"),
        endDate: end.format("YYYY-MM-DDT23:59:59")
      });

      setScores(responseData.data);
    }
  }


  const handleChangeCompany = (e: any) => {
    setSelectedCompany(e);
  }

  return (
    <>
      <div className='row'>
        <div className='col-lg-4'>
          <label className='form-label fw-bolder'>Company Section</label>
          <Select
            styles={customSelectStyles(true)}
            menuPortalTarget={document.body}
            onChange={(event) => handleChangeCompany(event)}
            value={selectedCompany}
            options={companies}
          />
        </div>
        <div className='col-lg-3'>
          <label className='form-label fw-bolder'>Date Range</label>
          <DateTimeRangeContainer
            ranges={ranges}
            start={start}
            style={{
              darkMode: true, standaloneLayout: { display: 'flex', maxWidth: 'fit-content' }
            }}
            end={end}
            local={local}
            applyCallback={applyCallback}
          >
            <input
              id="formControlsTextB"
              className='form-control form-control-solid'
              value={`${start.format(local.format)} - ${end.format(local.format)}`}
              type="text"
            />
          </DateTimeRangeContainer>
        </div>
      </div>
      <GenericTable
        title={'Native Ratings'}
        data={scores?.items}
        currentTotalRecords={scores?.totalRecords!!}
        currentPageNumber={scores?.pageNumber!!}
        columns={[
          {
            label: "#", name: "#", options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false
            }
          },
          {
            label: "FullName", name: "firstName", options: {
              customBodyRenderLite: (dataIndex) => {
                return (
                  <b>{scores?.items[dataIndex].firstName} {scores?.items[dataIndex].lastName}</b>
                )
              },
            },
          },
          { label: "Email", name: "email" },
          { label: "Phone Number", name: "phoneNumber" },
          {
            label: "#", name: "Id", options: {
              customHeadLabelRender: (options) => {
                return (<div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>)
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={scores?.items[dataIndex]?.id!!}
                    itemParam={`${scores?.items[dataIndex]?.firstName!!} ${scores?.items[dataIndex]?.lastName!!}`}
                    links={[
                      { type: 'user', value: '/account/users/' + scores?.items[dataIndex]?.id!! },

                    ]}
                    types={[]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false
            },
          }
        ]}
        customOptions={options}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
        Content={() => {
          return (
            <SaveChangesButton
              loading={loading}
              setLoading={setLoading}
              complete={complete}
              setComplete={setComplete}
              valid={true}
              submit={true}
              customClasses={!loading ? "btn-sm bg-transparent btn-outline-primary btn-icon btn-active-light-dark btn-circle btn-custom" : "btn-sm btn-secondary"}
              title={"<i className='fas fa-download text-gray-700'></i>"}
              setSubmit={() => getReports(start, end, selectedCompany!.value)} />
          )
        }
        }
      />
    </>
  )
}

export { NativeRatingsListModal }
